// firebase.js
import { initializeApp } from 'firebase/app';
import { getMessaging } from 'firebase/messaging';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getAnalytics, logEvent } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyB8hQQJqeOfP3pKSK9mVthJsgRJtNlZbEA",
  authDomain: "zetameet-d09ed.firebaseapp.com",
  projectId: "zetameet-d09ed",
  storageBucket: "zetameet-d09ed.appspot.com",
  messagingSenderId: "215414325767",
  appId: "1:215414325767:web:2d72c7ec7629e0ccf960a2",
  MeasurementId: "G-4FYS1QZWPW"
};

// Initialize Firebase only once
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const analytics = getAnalytics(app);

if (process.env.REACT_APP_USE_AUTH_EMULATOR === "true") {
  connectAuthEmulator(auth, "http://localhost:9099", { disableWarnings: true });
}

// Single messaging instance
const messaging = typeof window !== 'undefined' ? getMessaging(app) : null;

export { auth, messaging, analytics };





//changed this by the claude code
// import { initializeApp } from 'firebase/app';
// import { getMessaging } from 'firebase/messaging';
// import { getAuth, connectAuthEmulator } from 'firebase/auth';

// const firebaseConfig = {
//   apiKey: "AIzaSyB8hQQJqeOfP3pKSK9mVthJsgRJtNlZbEA",
//   authDomain: "zetameet-d09ed.firebaseapp.com",
//   projectId: "zetameet-d09ed",
//   storageBucket: "zetameet-d09ed.appspot.com",
//   messagingSenderId: "215414325767",
//   appId: "1:215414325767:web:2d72c7ec7629e0ccf960a2"
// };

// const app = initializeApp(firebaseConfig);
// const auth = getAuth(app);

// if (process.env.REACT_APP_USE_AUTH_EMULATOR === "true") {
//   connectAuthEmulator(auth, "http://localhost:9099", { disableWarnings: true });
// }
// let messagingInstance = null;

// const initializeMessaging = async () => {
//   if (!messagingInstance) {
//     messagingInstance = getMessaging(app);
//   }
//   return messagingInstance;
// };

// export { auth, initializeMessaging };





//origial working
// import { initializeApp } from "firebase/app";
// import { getMessaging, getToken } from "firebase/messaging";
// import { getAuth, connectAuthEmulator } from "firebase/auth";

// const firebaseConfig = {
//   apiKey: "AIzaSyB8hQQJqeOfP3pKSK9mVthJsgRJtNlZbEA",
//   authDomain: "zetameet-d09ed.firebaseapp.com",
//   projectId: "zetameet-d09ed",
//   storageBucket: "zetameet-d09ed.appspot.com",
//   messagingSenderId: "215414325767",
//   appId: "1:215414325767:web:2d72c7ec7629e0ccf960a2",
// };

// const app = initializeApp(firebaseConfig);
// const auth = getAuth(app);

// if (process.env.REACT_APP_USE_AUTH_EMULATOR === "true") {
//   connectAuthEmulator(auth, "http://localhost:9099", { disableWarnings: true });
// }

// let messagingInstance = null;

// const initializeMessaging = async () => {
//   if (!messagingInstance) {
//     messagingInstance = getMessaging(app);
//   }
//   return messagingInstance;
// };

// const getFCMToken = async (vapidKey) => {
//   const messaging = await initializeMessaging();
  
//   // Force a new registration each time
//   const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');
//   await navigator.serviceWorker.ready;

//   try {
//     const currentToken = await getToken(messaging, {
//       vapidKey,
//       serviceWorkerRegistration: registration,
//       forceRefresh: true // Add this to force a new token
//     });
    
//     if (currentToken) {
//       console.log('Token generated:', currentToken);
//       return currentToken;
//     } else {
//       console.log('No registration token available. Request permission first.');
//       return null;
//     }
//   } catch (error) {
//     console.error('Error getting token:', error);
//     throw error;
//   }
// };

// export { auth, initializeMessaging, getFCMToken };